export default __webpack_public_path__ + "static/media/Biblio - upute za korisnike v1.2.f856bfc2.pdf";